import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RadioButtonComponent } from './radio-button/radio-button.component';

@Component({
  selector: 'shared-ui-radio-button-group',
  imports: [NgTemplateOutlet, RadioButtonComponent, NgClass, FormField],
  templateUrl: './radio-button-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonGroupComponent<T extends string> {
  readonly label = input<string>();
  readonly labelTemplate = input<TemplateRef<{ $implicit: string }>>();
  readonly fieldTree = input.required<FieldTree<T>>();
  readonly radioButtonValuesToLabel = input.required<Record<T, string>>();
  readonly direction = input<'horizontal' | 'vertical'>('horizontal');

  readonly valuesToLabels = computed(
    () => Object.entries(this.radioButtonValuesToLabel()) as [T, string][],
  );

  clicked = output<void>();

  readonly fieldState = computed(() => this.fieldTree()());
  readonly name = computed(() => this.fieldState().keyInParent());
  readonly isValid = computed(() => this.fieldState().valid());
  readonly isDisabled = computed(() => this.fieldState().disabled());
}
